import { fmt } from 'components/IntlWrapper/IntlWrapper';
import { getLocaleFromLocalStorage } from 'utils/intl-wrapper';
const locale = getLocaleFromLocalStorage();

export const SAUDI_BANKS = [
  {
    value: 'Saudi_National_Bank',
    label: locale === 'en' ? 'The Saudi National Bank' : 'البنك الأهلي السعودي'
  },
  {
    value: 'Alrajhi Bank',
    label: locale === 'en' ? 'Alrajhi Bank' : 'مصرف الراجحي'
  },
  {
    value: 'Alinma Bank',
    label: locale === 'en' ? 'Alinma Bank' : 'مصرف الانماء'
  },
  {
    value: 'Samba Bank',
    label: locale === 'en' ? 'Samba Bank' : 'مجموعة سامبا المالية'
  },
  {
    value: 'Aljazira Bank',
    label: locale === 'en' ? 'Aljazira Bank' : 'بنك الجزيرة'
  },
  {
    value: 'Albilad Bank',
    label: locale === 'en' ? 'Albilad Bank' : 'بنك البلاد'
  },
  { value: 'Riyad Bank', label: locale === 'en' ? 'Riyad Bank' : 'بنك الرياض' },
  {
    value: 'The Saudi British Bank - SABB',
    label:
      locale === 'en'
        ? 'The Saudi British Bank - SABB'
        : 'البنك السعودي البريطاني (ساب)'
  },
  {
    value: 'Banque Saudi Fransi',
    label: locale === 'en' ? 'Banque Saudi Fransi' : 'البنك السعودي الفرنسي'
  },
  {
    value: 'Alawwal Bank',
    label: locale === 'en' ? 'Alawwal Bank' : 'البنك الاول'
  },
  {
    value: 'The Saudi Investement bank',
    label:
      locale === 'en' ? 'The Saudi Investement bank' : 'البنك السعودي للأستثمار'
  },
  {
    value: 'The Arab National Bank',
    label: locale === 'en' ? 'The Arab National Bank' : 'البنك العربي الوطني'
  },
  {
    value: 'Gulf International Bank',
    label: locale === 'en' ? 'Gulf International Bank' : 'بنك الخليج الدولي'
  },
  { value: 'Banque Misr', label: locale === 'en' ? 'Banque Misr' : 'بنك مصر' },
  {
    value: 'Emirates NBD',
    label: locale === 'en' ? 'Emirates NBD' : 'بنك الامارات دبي الوطني'
  },
  {
    value: 'Trade Bank of Iraq ',
    label: locale === 'en' ? 'Trade Bank of Iraq' : 'المصرف العراقي للتجارة'
  },
  {
    value: 'First Abu Dhabi Bank',
    label: locale === 'en' ? 'First Abu Dhabi Bank' : 'بنك ابو ظبي الاول'
  },
  {
    value: 'MUFG Bank',
    label: locale === 'en' ? 'MUFG Bank' : 'بنك إم يو أف جي'
  },
  {
    value: 'Qatar National Bank',
    label: locale === 'en' ? 'Qatar National Bank' : 'بنك قطر الوطني (QNB)'
  },
  {
    value: 'National Bank of Bahrain',
    label: locale === 'en' ? 'National Bank of Bahrain' : 'بنك البحرين الوطني'
  },
  {
    value: 'The National Bank of Kuwait',
    label: locale === 'en' ? 'The National Bank of Kuwait' : 'بنك الكويت الوطني'
  },
  { value: 'Bank Muscat', label: locale === 'en' ? 'Bank Muscat' : 'بنك مسقط' },
  {
    value: 'Deutsche Bank AG',
    label: locale === 'en' ? 'Deutsche Bank AG' : 'دويتشه بنك'
  },
  {
    value: 'BNP Paribas S.A',
    label: locale === 'en' ? 'BNP Paribas S.A' : 'بي ان بي باريبا'
  },
  {
    value: 'JPMorgan Chase & Co.',
    label: locale === 'en' ? 'JPMorgan Chase & Co.' : 'جي بي مورغان تشيس'
  },
  {
    value: 'Industrial and Commercial Bank of China',
    label:
      locale === 'en'
        ? 'Industrial and Commercial Bank of China'
        : 'البنك الصناعي والتجاري الصيني'
  },
  {
    value: 'Standard Chartered',
    label: locale === 'en' ? 'Standard Chartered' : 'ستاندرد تشارترد'
  },
  {
    value: 'Credit Suisse',
    label: locale === 'en' ? 'Credit Suisse' : 'كريدت سويس العربية السعودية'
  },
  {
    value: 'National Bank of Pakistan',
    label:
      locale === 'en' ? 'National Bank of Pakistan' : 'البنك الوطني الباكستاني'
  }
];

export const EGYPT_BANKS = [
  {
    value: 'AAIB - البنك العربى الافريقى الدولى',
    label: 'AAIB - البنك العربى الافريقى الدولى'
  },
  {
    value: 'ABC - بنك المؤسسة العربية المصرفية – مصر',
    label: 'ABC - بنك المؤسسة العربية المصرفية – مصر'
  },
  {
    value: 'ABK - بنك الأهلي الكويتي - مصر',
    label: 'ABK - بنك الأهلي الكويتي - مصر'
  },
  { value: 'ABRK - بنك البركة - مصر', label: 'ABRK - بنك البركة - مصر' },
  { value: 'ADCB - بنك ابو ظبي التجاري', label: 'ADCB - بنك ابو ظبي التجاري' },
  {
    value: 'ADIB - مصرف أبو ظبي الإسلامي',
    label: 'ADIB - مصرف أبو ظبي الإسلامي'
  },
  { value: 'AIB - بنك الإستثمار العربي', label: 'AIB - بنك الإستثمار العربي' },
  { value: 'ARAB - البنك العربى', label: 'ARAB - البنك العربى' },
  {
    value: 'ARIB - المصرف العربي الدولي',
    label: 'ARIB - المصرف العربي الدولي'
  },
  { value: 'AUB - البنك الأهلي المتحد', label: 'AUB - البنك الأهلي المتحد' },
  { value: 'AUDI - بنك عودة', label: 'AUDI - بنك عودة' },
  { value: 'AWB - التجاري وفا بنك', label: 'AWB - التجاري وفا بنك' },
  { value: 'BBE - بنك باركليز', label: 'BBE - بنك باركليز' },
  { value: 'BDC - بنك القاهرة', label: 'BDC - بنك القاهرة' },
  { value: 'BLOM - بنك بلوم - مصر', label: 'BLOM - بنك بلوم - مصر' },
  { value: 'BOA - بنك الأسكندرية', label: 'BOA - بنك الأسكندرية' },
  {
    value: 'CAE - بنك كريدي أجريكول مصر',
    label: 'CAE - بنك كريدي أجريكول مصر'
  },
  { value: 'CBE - البنك المركزي المصري', label: 'CBE - البنك المركزي المصري' },
  { value: 'CIB - البنك التجاري الدولي', label: 'CIB - البنك التجاري الدولي' },
  {
    value: 'EDBE - البنك المصرى لتنمية الصادرات',
    label: 'EDBE - البنك المصرى لتنمية الصادرات'
  },
  { value: 'EGB - البنك المصرى الخليجى', label: 'EGB - البنك المصرى الخليجى' },
  {
    value: 'ENBD - بنك الإمارات دبي الوطنى',
    label: 'ENBD - بنك الإمارات دبي الوطنى'
  },
  {
    value: 'FAIB - بنك فيصل الإسلامى المصرى',
    label: 'FAIB - بنك فيصل الإسلامى المصرى'
  },
  { value: 'HDB - بنك التعمير والإسكان', label: 'HDB - بنك التعمير والإسكان' },
  {
    value: 'HSBC - بنك اتش اس بى سى مصر',
    label: 'HSBC - بنك اتش اس بى سى مصر'
  },
  { value: 'MASH - بنك المشرق', label: 'MASH - بنك المشرق' },
  { value: 'MIDB - بنك مصر ايران', label: 'MIDB - بنك مصر ايران' },
  { value: 'MISR - بنك مصر', label: 'MISR - بنك مصر' },
  { value: 'NBAD - بنك أبو ظبى الوطنى', label: 'NBAD - بنك أبو ظبى الوطنى' },
  { value: 'NBE - البنك الأهلى المصرى', label: 'NBE - البنك الأهلى المصرى' },
  {
    value: 'NBG - البنك الأهلي اليوناني - مصر',
    label: 'NBG - البنك الأهلي اليوناني - مصر'
  },
  {
    value: 'NBK - بنك الكويت الوطنى - مصر',
    label: 'NBK - بنك الكويت الوطنى - مصر'
  },
  {
    value: 'PDAC - البنك الرئيسي للتنمية والإئتمان الزراعي',
    label: 'PDAC - البنك الرئيسي للتنمية والإئتمان الزراعي'
  },
  {
    value: 'QNB - بنك قطر الوطنى الأهلى',
    label: 'QNB - بنك قطر الوطنى الأهلى'
  },
  {
    value: 'SAIB - بنك الشركة العربية المصرفية الدولية',
    label: 'SAIB - بنك الشركة العربية المصرفية الدولية'
  },
  { value: 'SCB - بنك قناة السويس', label: 'SCB - بنك قناة السويس' },
  { value: 'UB - المصرف المتحد', label: 'UB - المصرف المتحد' },
  {
    value: 'EALB - البنك العقاري المصري العربي',
    label: 'EALB - البنك العقاري المصري العربي'
  },
  {
    value: 'ABE - البنك الزراعي المصري',
    label: 'ABE - البنك الزراعي المصري'
  },
  {
    value: 'FAB - بنك أبوظبي الأول',
    label: 'FAB - بنك أبوظبي الأول'
  }
];

export const BANKS_HOTLINE_IBAN_LINK = {
  'ABE - البنك الزراعي المصري': { hotline: null, link: null },
  'EALB - البنك العقاري المصري العربي': { hotline: '19939', link: null },
  'BBE - بنك باركليز': { hotline: null, link: null },
  'AAIB - البنك العربى الافريقى الدولى': { hotline: '19555', link: null },
  'ABC - بنك المؤسسة العربية المصرفية – مصر': { hotline: '19123', link: null },
  'ABK - بنك الأهلي الكويتي - مصر': {
    hotline: '19322',
    link: 'https://www.abkegypt.com/Arabic/Remmittance_ABK.aspx?id=6'
  },
  'ABRK - بنك البركة - مصر': {
    hotline: '19373',
    link: 'https://portal.albaraka.bh/ar/services/other/iBanGenerator.aspx'
  },
  'ADCB - بنك ابو ظبي التجاري': { hotline: '16862', link: null },
  'ADIB - مصرف أبو ظبي الإسلامي': {
    hotline: '19951',
    link: 'https://www.adib.eg/Arabic/IBAN/'
  },
  'AIB - بنك الإستثمار العربي': { hotline: '16697', link: null },
  'ARAB - البنك العربى': {
    hotline: '19100',
    link: 'https://www.arabbank.com.eg/mainmenu/home/ways-to-bank/arabi-online'
  },
  'ARIB - المصرف العربي الدولي': {
    hotline: '19604',
    link: 'https://aib.com.eg/ar/IBAN-generator'
  },
  'AUB - البنك الأهلي المتحد': {
    hotline: '19072',
    link: 'https://www.ahliunited.com/eg/iban-genrator/'
  },
  'AUDI - بنك عودة': {
    hotline: '16555',
    link: 'https://www.bankaudi.com.eg/arabic/international-bank-account-number'
  },
  'AWB - التجاري وفا بنك': {
    hotline: '16222',
    link: 'https://www.attijariwafabank.com.eg/iban-form/'
  },

  'BDC - بنك القاهرة': { hotline: '16990', link: null },
  'BLOM - بنك بلوم - مصر': { hotline: '19233', link: null },
  'BOA - بنك الأسكندرية': {
    hotline: '19033',
    link: 'https://www.alexbank.com/retail/iban.html'
  },
  'CAE - بنك كريدي أجريكول مصر': {
    hotline: '19191',
    link: 'https://www.ca-egypt.com/ar/%D8%B1%D9%82%D9%85-%D8%A7%D9%84%D8%AD%D8%B3%D8%A7%D8%A8-%D8%A7%D9%84%D9%85%D8%B5%D8%B1%D9%81%D9%8A-%D8%A7%D9%84%D8%AF%D9%88%D9%84%D9%8A-iban/?bank_segment=personal-banking'
  },
  'CIB - البنك التجاري الدولي': {
    hotline: '19666',
    link: 'https://www.cibeg.com/arabic/Personal/waystobank/Pages/generateorvalidateiban.aspx'
  },
  'EDBE - البنك المصرى لتنمية الصادرات': { hotline: '16710', link: null },
  'EGB - البنك المصرى الخليجى': {
    hotline: '19342',
    link: 'https://eg-bank.com/En/IBAN'
  },
  'ENBD - بنك الإمارات دبي الوطنى': {
    hotline: '16664',
    link: 'https://www.emiratesnbd.com.eg/egypt-ar/iban/'
  },
  'FAIB - بنك فيصل الإسلامى المصرى': { hotline: '19851', link: null },
  'HDB - بنك التعمير والإسكان': { hotline: '19995', link: null },
  'HSBC - بنك اتش اس بى سى مصر': {
    hotline: '19007',
    link: 'https://www.hsbc.com.eg/help/what-is-iban/'
  },
  'MASH - بنك المشرق': { hotline: '19677', link: null },
  'MIDB - بنك مصر ايران': { hotline: '19189', link: null },
  'MISR - بنك مصر': {
    hotline: '19888',
    link: 'https://www.banquemisr.com/ar/pages/ibanconverter.aspx?csrt=1515224637922144315'
  },
  'NBAD - بنك أبو ظبى الوطنى': { hotline: '19977', link: null },
  'NBE - البنك الأهلى المصرى': {
    hotline: '19623',
    link: 'https://www.nbe.com.eg/NBE/E/#/AR/ProductDetails?inParams=%7B%22CategoryID%22%3A%22selfservices%22%2C%22ProductID%22%3A%2217671%22%7D'
  },

  'NBK - بنك الكويت الوطنى - مصر': {
    hotline: '19336',
    link: 'https://www.nbk.com/ar/egypt/personal/ways-to-bank/International-Banking-Account-Number--IBAN-.html'
  },

  'QNB - بنك قطر الوطنى الأهلى': {
    hotline: '19700',
    link: 'https://www.qnbalahli.com/sites/qnb/qnbegypt/page/ar/aribanconverter.html'
  },
  'SAIB - بنك الشركة العربية المصرفية الدولية': {
    hotline: '16668',
    link: null
  },
  'SCB - بنك قناة السويس': {
    hotline: '19093',
    link: 'https://scbank.com.eg/Ar/Get_IBAN.aspx'
  },
  'UB - المصرف المتحد': {
    hotline: '19200',
    link: 'https://www.theubeg.com/ar/ub-services/international-payments'
  },
  'NBG - البنك الأهلي اليوناني - مصر': {
    hotline: '16272',
    link: null
  },
  'PDAC - البنك الرئيسي للتنمية والإئتمان الزراعي': {
    hotline: '233327259',
    link: null
  },
  'FAB - بنك أبوظبي الأول': {
    hotline: null,
    link: null
  }
};

export const IBAN_GUIDE = (locale = 'en') => {
  return `https://bosta.freshdesk.com/a/solutions/articles/36000269385?lang=${locale}`;
};

export const SANDBOX_PAYLOAD = (webhook = false) => {
  return {
    type: 10,
    specs: {
      size: 'SMALL',
      packageDetails: {
        itemsCount: 5,
        document: 'Document',
        description: 'Desc.'
      }
    },
    returnSpecs: {
      size: 'SMALL',
      packageDetails: {
        itemsCount: 5,
        document: 'Document',
        description: 'Desc.'
      }
    },
    notes: 'Welcome Note',
    cod: 50,
    dropOffAddress: {
      district: 'Maadi',
      firstLine: 'Maadi',
      secondLine: 'Nasr  City',
      buildingNumber: '123',
      floor: '4',
      apartment: '2',
      isWorkAddress: true,
      zone: 'Maadi & Muqattam',
      city: 'Cairo'
    },
    returnAddress: {
      district: 'Maadi',
      firstLine: 'Maadi',
      secondLine: 'Nasr  City',
      buildingNumber: '123',
      floor: '4',
      apartment: '2',
      isWorkAddress: true,
      zone: 'Maadi & Muqattam',
      city: 'Cairo'
    },
    allowToOpenPackage: true,
    businessReference: '43535252',
    receiver: {
      firstName: 'Sasuke',
      lastName: 'Uchiha',
      phone: '01065685435',
      email: 'ahmed@ahmed.com'
    },
    ...(webhook
      ? { webhookUrl: 'https://api.webhooks.com/services/T0000000' }
      : null)
  };
};

export const SANDBOX_HEADERS = (key) => ({
  Authorization: key || 'API_KEY'
});

export const TAG_METHODS = {
  post: {
    className: 'br_tag-post',
    titleKey: 'post'
  },
  get: {
    className: 'br_tag-get',
    titleKey: 'get'
  }
};

export const PICKED_UP_STATE = 'Picked Up';

export const SANBOX_CREATE_ORDER_ENDPOINT =
  'https://sandbox.bosta.co/api/v2/sandbox/deliveries';

export const CREATE_PICKUP_REQUEST_ENDPOINT =
  'http://api.bosta.co/api/v2/pickups';

export const CREATE_ORDER_ENDPOINT = 'http://api.bosta.co/api/v2/deliveries';

export const PRINT_AIR_WAYBILL_ENDPOINT =
  'http://api.bosta.co/api/v2/deliveries/awb/{id}';

export const API_DOCUMENTATION_GUIDE = 'https://docs.bosta.co/';

export const shopify_view_guide = `https://bosta.freshdesk.com/en/support/solutions/articles/36000414774`;

export const shopify_view_plugins =
  'https://apps.shopify.com/bosta-shipping-app?surface_detail=bosta&surface_inter_position=1&surface_intra_position=1&surface_type=search';

export const woocommerce_view_guide = `https://bosta.freshdesk.com/en/support/solutions/articles/36000414774`;

export const woocommerce_view_plugins =
  'https://wordpress.org/plugins/bosta-woocommerce/';

export const NEW_FEATURES_ROUTES = [
  'personalinfo',
  'businessaccount',
  'pricingplan',
  'pickuplocations',
  'accountpreferences',
  'apiintegration',
  'plugins',
  'teamsmembers'
];

export const CITIES_NAMES_LINK = {
  EG: 'https://docs.google.com/spreadsheets/d/1LGXIU_ThCnZlAHgsIX1QXd0wpaANOdlZ/edit?usp=sharing&ouid=101960885017486726475&rtpof=true&sd=true',
  SA: 'https://docs.google.com/spreadsheets/d/1nc_yLGpeoIraA7_u6oQO8TUmlA0_lRqr/edit?usp=sharing&ouid=101960885017486726475&rtpof=true&sd=true'
};

export const API_SUPER_ADMIN_ACCESS = 'API_SUPER_ADMIN_ACCESS';

export const API_KEYS_SCOPES = {
  API_READ_ACCESS: fmt({
    id: 'settings.api_integration.integrated_view.table.permission_scopes.read'
  }),
  API_READ_WRITE_ACCESS: fmt({
    id: 'settings.api_integration.integrated_view.table.permission_scopes.read_wite'
  }),
  API_SUPER_ADMIN_ACCESS: fmt({
    id: 'settings.api_integration.integrated_view.table.permission_scopes.full_access'
  })
};

export const API_KEYS_SCOPES_OPTIONS = [
  { value: 'API_READ_ACCESS', label: API_KEYS_SCOPES.API_READ_ACCESS },
  {
    value: 'API_READ_WRITE_ACCESS',
    label: API_KEYS_SCOPES.API_READ_WRITE_ACCESS
  },
  {
    value: 'API_SUPER_ADMIN_ACCESS',
    label: API_KEYS_SCOPES.API_SUPER_ADMIN_ACCESS
  }
];

export const FALL_BACK_COUNTRY_NAME = 'Saudi Arabia';

export const BANK_TYPES = [
  {
    label: fmt({
      id: 'settings.payment_method.bank_details_modal.domestic'
    }),
    value: 'DOMESTIC'
  },
  {
    label: fmt({
      id: 'settings.payment_method.bank_details_modal.international'
    }),
    value: 'INTERNATIONAL'
  }
];

export const DOMESTIC_TYPE = 'DOMESTIC';
export const INTERNATIONAL_TYPE = 'INTERNATIONAL';

export const BANK_DETAILS_OTP_BLOCK_DURATION = 120;

export const DAYS_TO_UPDATE_AGAIN = 15;

export const UPDATE_MSG_STATUS = {
  INFO: 'info',
  WARNING: 'warning'
};

export const CONDITIONAL_SHIPPING_FEES = (isSmallMobileScreen) => [
  {
    label: fmt({
      id: `products.sllr_store.setting_page.${
        isSmallMobileScreen ? 'plans.flat' : 'apply_flat_rate'
      }`
    }),
    value: 'flat'
  },
  {
    label: fmt({
      id: `products.sllr_store.setting_page.${
        isSmallMobileScreen ? 'plans.custom' : 'apply_custom_rate'
      }`
    }),
    value: 'custom'
  }
];

export const CONDITION_FEES_OPTIONS = {
  flat: 'flat',
  custom: 'custom'
};

export const SHIPPING_COURIER_TYPE = {
  WITH_BOSTA: 'with_bosta',
  WITH_OTHER: 'with_other',
  ASK_ME_EVERY_TIME: 'ask_me_every_time'
};
